<template>
  <div>
    <template v-if="type === 'global'">
      <div class="w3-row">
        <div class="w3-col s12 m8">
          <div class="sectionHeader" style="text-align:center;">
            <h5>Schedule</h5>
          </div>
          <div class="whiteContainer">
            Your ad will start today, {{selectedAd.start | date('longDate')}} and next renew {{selectedAd.end | date('longDate')}}.
          </div>
          <div class="sectionHeader" style="text-align:center;">
            <h5>Cost Description</h5>
          </div>
          <div class="whiteContainer">
            Global Ads are priced monthly at $49 flat rate, renewed automatically each month unless paused or cancelled.
          </div>
          <div class="sectionHeader" style="text-align:center;">
            <h5>Cost</h5>
          </div>
          <div class="whiteContainer">
            Global Ad ({{selectedAd.start | date('shortDate')}} - {{selectedAd.end | date('shortDate')}})
            <span class="w3-right w3-right-align">$49.00</span>
          </div>
        </div>
        <div class="w3-col s12 m4">
          <div class="sectionHeader" style="text-align:center;">
            <h5>Calendar</h5>
          </div>
          <div class="w3-padding w3-dark-teal w3-center" style="margin:0 4px;">
            {{monthTitle}} {{year}}
          </div>
          <div class="w3-padding flowGrid col7 w3-center w3-dark-grey" style="margin:0 4px;">
            <div>Su</div>
            <div>Mo</div>
            <div>Tu</div>
            <div>We</div>
            <div>Th</div>
            <div>Fr</div>
            <div>Sa</div>
          </div>
          <div class="whiteContainer">
            <div v-for="(day, index) in daysOfMonth" :key="index" class="flowGrid calendarGrid col7 gap0 w3-center">
              <div class="w3-padding gridBorder" :class="startDate(dayOfWeek)" v-for="(dayOfWeek, index) in day.days" :key="index">
                {{dayOfWeek | date('dayNumber')}}
              </div>
            </div>
          </div>
          <div style="margin:0 4px;">
            <button class="w3-button w3-green w3-block" @click="$emit('saveSchedule')">Continue to Checkout</button>
          </div>
        </div>
      </div>
    </template>
    <template v-if="type === 'event'">
      <div class="w3-row">
        <div class="w3-col s12 m8">
          <div class="sectionHeader" style="text-align:center;">
            <h5>Schedule</h5>
          </div>
          <div class="whiteContainer">
            Your ad will start {{adStart | date('longDate')}} and end {{adEnd | date('longDate')}}.
          </div>
          <div class="sectionHeader" style="text-align:center;">
            <h5>Cost Description</h5>
          </div>
          <div class="whiteContainer">
            Event page ads are priced at $2 per day from the selected start date until the last day of the selected event.
          </div>
          <div class="sectionHeader" style="text-align:center;">
            <h5>Cost</h5>
          </div>
          <div class="whiteContainer">
            Event Ad ({{adStart | date('shortDate')}} - {{adEnd | date('shortDate')}})
            <span class="w3-right w3-right-align" style="font-weight:400;">{{selectedAd.billing.cost / 100 | currency()}}</span>
          </div>
        </div>
        <div class="w3-col s12 m4">
          <div class="sectionHeader" style="text-align:center;">
            <h5>Calendar</h5>
          </div>
          <div class="sectionHeader w3-display-container w3-center" style="margin-bottom:0; background:#004b54; color:#fafafa">
            <button type="button" class="w3-button w3-display-left btnBack" @click="previousMonth()"><font-awesome-icon icon="arrow-left"></font-awesome-icon></button>
            <h5>{{monthTitle}} {{year}}</h5>
            <button type="button" class="w3-button w3-display-right btnNext" @click="nextMonth()"><font-awesome-icon icon="arrow-right"></font-awesome-icon></button>
          </div>

          <div class="w3-padding flowGrid col7 w3-center w3-dark-grey pointer" style="margin:0 4px;">
            <div>Su</div>
            <div>Mo</div>
            <div>Tu</div>
            <div>We</div>
            <div>Th</div>
            <div>Fr</div>
            <div>Sa</div>
          </div>
          <div class="whiteContainer pointer noSelect">
            <div v-for="(day, index) in daysOfMonth" :key="index" class="flowGrid calendarGrid col7 gap0 w3-center">
              <div class="w3-padding gridBorder" v-for="(dayOfWeek, index) in day.days" :key="index" @click="setAdStartDate(dayOfWeek)" :class="activeDay(dayOfWeek)">
                {{dayOfWeek | date('dayNumber')}}
              </div>
            </div>
          </div>
          <div style="margin:0 4px;">
            <button class="w3-button w3-green w3-block" @click="$emit('saveSchedule')">Continue to Checkout</button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import * as moment from 'moment'

  export default {
    name: 'schedule',
    props: ['type','stepsObj'],
    created() {
      if (this.selectedAd.start) {
        this.setAdStartDate(this.selectedAd.start)
      } else {
        this.setAdStartDate(moment())
      }
    },
    data() {
      return {
        startDay: moment().startOf('month').startOf('week'),
        endDay: moment().endOf('month').endOf('week'),
        monthOffset: 0,
        monthTitle: moment().format('MMMM'),
        year: moment().format('YYYY')
      }
    },
    computed: {
      daysOfMonth() {
        let calendar = []
        
        let date = this.startDay.clone().subtract(1, 'day')
        while (date.isBefore(this.endDay, 'day')) {
          calendar.push({
            days: Array(7).fill(0).map(() => date.add(1, 'day').clone())
          })
        }
        return calendar
      },
      adStart() {
        return moment(this.selectedAd.start).format()
      },
      adEnd() {
        return moment(this.selectedAd.end).format()
      },
      ...mapState([
        'selectedAd'
      ])
    },
    methods: {
      startDate(date) {
        if (!moment(date).isSame(this.selectedAd.start, 'month')) {
          return 'w3-text-light-grey'
        }
        if (moment(date).isSame(this.selectedAd.start, 'day')) {
          return 'w3-dark-blue'
        } else {
          return
        }
      },
      activeDay(date) {
        let startDay = moment(this.selectedAd.start).startOf('day')
        let endDay = moment(this.selectedAd.end).startOf('day')
        if (moment(date).isBetween(startDay, endDay, 'days', '[]')) {
          return 'w3-dark-blue'
        } else {
          if (moment(date).isBetween(moment().startOf('day'), endDay, 'days', '[]')) {
            return 'w3-medium-grey'
          }
          if (!moment(date).isSame(moment().add(this.monthOffset, 'months'), 'month')) {
            return 'w3-text-light-grey'
          }
          return
        }
      },
      nextMonth() {
        let nowMonth = moment().add(this.monthOffset, 'months')
        this.startDay = moment(nowMonth).add(1, 'months').startOf('month').startOf('week')
        this.endDay = moment(nowMonth).add(1, 'months').endOf('month').endOf('week')
        this.monthTitle = moment(nowMonth).add(1, 'months').format('MMMM')
        this.year = moment(nowMonth).add(1, 'months').format('YYYY')
        this.monthOffset++
      },
      previousMonth() {
        let nowMonth = moment().add(this.monthOffset, 'months')
        this.startDay = moment(nowMonth).subtract(1, 'months').startOf('month').startOf('week')
        this.endDay = moment(nowMonth).subtract(1, 'months').endOf('month').endOf('week')
        this.monthTitle = moment(nowMonth).subtract(1, 'months').format('MMMM')
        this.year = moment(nowMonth).subtract(1, 'months').format('YYYY')
        this.monthOffset--
      },
      setAdStartDate(date) {
        if (moment(date).isAfter(this.selectedAd.end)) {
          return
        }
        if (moment(date).isBefore(moment().startOf('day'))) {
          return
        }
        let ad = this.selectedAd
        let days = moment(ad.end).diff(moment(date).subtract(1, 'days'), 'days')
        ad.start = moment(date).format()
        ad.billing.cost = days * 200
        this.$store.commit('setSelectedAd', ad)
        this.$store.dispatch('updateAd', this.selectedAd)
      }
    }
  }
</script>

<style scoped>
.noSelect {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>
